export default __webpack_public_path__ + "static/media/09_Get-arty.e307dcf3.jpg";